import { render, staticRenderFns } from "./cModalOtrosIngresos.vue?vue&type=template&id=4d2492a8&scoped=true"
import script from "./cModalOtrosIngresos.vue?vue&type=script&lang=js"
export * from "./cModalOtrosIngresos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2492a8",
  null
  
)

export default component.exports